<script>
import Layout from "@/views/layouts/default";
import appConfig from "@/app.config";
import simplebar from "simplebar-vue";
import Pusher from "pusher-js";

import ChatJob from "./chat-job.vue";
import ChatAdmin from "./chat-admin.vue";

export default {
  name: "Chat",
  page: {
    title: "Chat",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    Layout,
    ChatJob,
    ChatAdmin,
    simplebar
  },
  data() {
    return {
      filter: {
        from: 0,
        keyword: null,
      },
      activeChat: null,
      lastChatAdmin: {
        message: "",
        time: "",
        totalUnread: 0
      },
      chatRoomJob: null,
      chatMessages: [],
      chatJobMeta: {
        page: 1,
        per_page: 10,
        orderby: 'last_message_at',
        sort: 'desc',
        total_page: 0,
      }
    };
  },
  watch: {
    filter: {
      handler(val) {
        if (val.from == 0) {
          this.getUnreadChatAdmin()
        } else {
          this.getChatRoomChatJob()
        }
      },
      deep: true
    }
  },
  mounted() {
    this.subscribe()

    if (this.$route.query.role !== undefined) {
      if (this.$route.query.role == 'truck_owner') {
        this.filter.from = 1
      }
      if (this.$route.query.role == 'driver') {
        this.filter.from = 2
      }
    } else {
      this.getUnreadChatAdmin()
    }

    if (this.$route.query.room !== undefined) {
      this.showChatList('chat-job')
    }
  },
  methods: {
    filterChat() {},
    subscribe () {
      const pusher = new Pusher(process.env.VUE_APP_PUSHER_KEY, { cluster: process.env.VUE_APP_PUSHER_CLUSTER })
      pusher.subscribe(`user-${this.$store.state.userdata.id}`)
      
      // chat admin
      pusher.bind('chat-admin', (data) => {
        console.log(data)
        if (data !== undefined && data.sender_id === 1) {
          this.lastChatAdmin = {
            message: data.message,
            time: data.created_at,
            totalUnread: this.lastChatAdmin.totalUnread + 1
          }
        }
      })
      // chat job
      pusher.bind('chat-job', (data) => {
        if (data !== undefined) {
          console.log(data)
          const indexChat = this.chatMessages.findIndex(item => item.id === data.chat_job_id)
          if (indexChat < 0) {
            console.log(this.chatMessages[indexChat])
            this.chatMessages[indexChat].last_message.message = data.message
          } else {
            this.getChatRoomChatJob()
          }
        }
      })
    },
    showChatList(type, room = null) {
      this.activeChat = null
      this.activeChat = type
      this.chatRoomJob = room

      if (type == 'chat-job') {
        const indexRoom = this.chatMessages.findIndex(item => item.id === room.id)
        if (indexRoom >= 0) {
          this.chatMessages[indexRoom].total_unread_message = 0
        }
      } else {
        this.lastChatAdmin.totalUnread = 0
      }
    },
    getChatRoomChatJob() {
      this.$axios.get(`/v1/chat_job`, {
        params: { ...this.chatJobMeta, role: this.filter.from == 1 ? 'truck_owner' : 'driver' }
      })
        .then(response => {
          if (response.data.data.rows !== undefined && response.data.data.rows.length > 0) {
            if (this.chatJobMeta.page == 1) {
              this.chatMessages = response.data.data.rows
            } else {
              this.chatMessages = [...this.chatMessages, ...response.data.data.rows]
            }
          }
        })
    },
    getUnreadChatAdmin() {
      this.$axios.get('/v1/chat_admin/total_unread_message')
        .then(response => {
          this.lastChatAdmin = {
              message: response.data.data.last_message ? response.data.data.last_message.message : "",
              time: response.data.data.last_message ? response.data.data.last_message.created_at : "",
              totalUnread: response.data.data.total_unread_message
            }
        })
    }
  }
};
</script>

<template>
  <Layout>
    <!-- start page title -->
    <div class="row align-items-center">
      <div class="col-sm-12">
        <div class="page-title-box">
          <h4 class="font-size-18">Chat</h4>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xl-4">
        <b-tabs v-model="filter.from" align="center">
          <b-tab title="Admin"></b-tab>
          <b-tab title="Truck Owner"></b-tab>
          <b-tab title="Driver"></b-tab>
        </b-tabs>
        <div class="card">
          <div class="card-body">
            <b-form @submit.prevent="filterChat">
              <b-form-group
                label-cols="12"
                label-for="search-input"
              >
                <b-form-input v-model="filter.keyword" type="search" id="search-input" placeholder="Search..."></b-form-input>
              </b-form-group>
            </b-form>
            <div class="list-chat">
              <simplebar v-if="filter.from > 0" :style="`max-height: 385px`">
                <div v-for="(chat, index) in chatMessages" :key="index" class="d-flex justify-content-left cursor-pointer sender p-2" @click="showChatList('chat-job', chat)">
                  <img :src="chat.user_1.profile_picture" alt="male" class="avatar-xs rounded-circle mr-2" v-if="chat.user_1_role !== 'logistic_company'" />
                  <img :src="chat.user_2.profile_picture" alt="male" class="avatar-xs rounded-circle mr-2" v-if="chat.user_2_role !== 'logistic_company'" />
                  <div class="w-100">
                    <span v-if="chat.user_1_role !== 'logistic_company'" class="font-weight-medium">
                      {{ chat.user_1.full_name }}
                    </span>
                    <span v-if="chat.user_2_role !== 'logistic_company'" class="font-weight-medium">
                      {{ chat.user_2.full_name }}
                    </span>
                    <br />
                    <span v-if="chat.last_message !== null">
                      {{ chat.last_message.message | cut_text(35) }}
                    </span>
                  </div>
                  <span class="float-right font-size-12">
                    {{ chat.last_message ? chat.last_message.created_at : chat.created_at | time_only }}
                    <span
                      v-show="chat.total_unread_message !== 0"
                      class="badge-notif"
                      :data-badge="chat.total_unread_message"
                    ></span>
                  </span>
                </div>
              </simplebar>
              <div v-if="filter.from == 0" class="d-flex justify-content-left cursor-pointer sender p-2" @click="showChatList('chat-admin')">
                <img src="@/assets/images/users/operator.png" alt="male" class="avatar-xs rounded-circle mr-2" />
                <div class="w-100">
                  <span class="font-weight-medium">Admin</span><br />
                  <span v-if="lastChatAdmin.message">{{ lastChatAdmin.message | cut_text(35) }}</span>
                </div>
                <span class="float-right font-size-12" v-if="lastChatAdmin.time">
                  {{ lastChatAdmin.time | time_only }}
                  <span
                      v-show="lastChatAdmin.totalUnread !== 0"
                      class="badge-notif"
                      :data-badge="lastChatAdmin.totalUnread"
                    ></span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-8">
        <ChatJob v-if="activeChat == 'chat-job'"  :chat-room-detail="chatRoomJob" :role="this.filter.from" />
        <ChatAdmin v-if="activeChat == 'chat-admin'" />
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<style>
.badge-notif {
  position: relative;
}

.badge-notif[data-badge]:after {
  content: attr(data-badge);
  position: absolute;
  top: 15px;
  right: 1px;
  font-size: 0.8em;
  background: #e53935;
  color: white;
  width: 18px;
  height: 18px;
  text-align: center;
  line-height: 18px;
  border-radius: 50%;
}
</style>